module.exports = "<!-- <form class=\"sidebar-form\"></form> -->\r\n"